import Axios from "axios";
import { handleAPIError } from "../utils";
import useStore from "../slices";
import { ServiceEndpoints } from "../constants";
import { setLogout, setToken } from "slices/auth/login/reducer";
import { getRefreshToken } from "./auth.service";

const config = {
  baseURL: process.env.REACT_APP_API_URL || "https://api.pappermap.com/",
  responseType: "json",
  timeout: 20000,
};

const axios = Axios.create(config);

const url_exceptions = ["api/v1/user/login", "api/v1/user/signup"];
axios.interceptors.request.use(function (config: any) {
  const token = useStore.getState()?.Login?.accessToken;

  config.headers["X-Requested-With"] = "XMLHttpRequest";
  url_exceptions.every((url) => {
    if (url === config.url) {
      return false;
    } else {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.Accept = "application/json";
    }
  });
  return config;
});

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  async function (error) {
    handleAPIError(error, false);
    if (
      error.config.url === ServiceEndpoints.REFRESH &&
      error.response.status === 401
    ) {
      useStore.dispatch(setLogout());
      return Promise.reject(error);
    }
    if (
      error.response &&
      error.response.status === 401 &&
      !error.config._retry
    ) {
      error.config._retry = true;
      const refreshToken = useStore.getState().Login.refreshToken;
      if (refreshToken) {
        try {
          const refreshData = await getRefreshToken(refreshToken);
          const newAccessToken = refreshData.access;
          const newRefreshToken = refreshData.refresh;

          // Update tokens
          useStore.dispatch(
            setToken({
              accessToken: newAccessToken,
              refreshToken: newRefreshToken,
            })
          );

          // Retry the original request with updated tokens
          error.config.headers.Authorization = `Bearer ${newAccessToken}`;
          return axios(error.config)
            .then((response) => {
              // Reload the page after successfully refreshing tokens and retrying request
              window.location.reload();
              return response;
            })
            .catch((retryError) => {
              console.error("Failed to retry request:", retryError);
              throw retryError;
            });
        } catch (refreshError) {
          console.error("Failed to refresh token:", refreshError);
          throw refreshError;
        }
      } else {
        // If no refreshToken, logout the user
        useStore.dispatch(setLogout());
      }
    }
    return Promise.reject(error);
  }
);

export { axios };
